import { Link } from 'react-router-dom';

// Theme UI
import { Tooltip } from '@mui/material';
import { RichTextReadOnly } from 'mui-tiptap';

// Utils
import { dateHeader, formatCellDate } from './timeModeCell';

// Types
import { Comment } from '../../types/Comment';
import { AppPermissions } from '../../constants/Permissions';

// Components
import GridAction from '../../components/common/GridAction';

export const makeCommentListColumn = (onDeleted: (id: string) => void, onEdit: (comment: Comment) => void, extensions: any) => {
  const col = [
    {
      id: 'edit',
      header: '',
      accessorKey: '.',
      size: 75,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        const { id } = row.original as Comment;
        return (
          <GridAction
            onEdit={onEdit}
            onDeleted={onDeleted}
            editPermission={AppPermissions.Comment.Edit}
            deletePermission={AppPermissions.Comment.Delete}
            isDisabled={row.original.isSecondaryReference}
            row={row.original}
            id={id}
          />
        );
      },
    },
    {
      header: dateHeader('Date'),
      accessorKey: 'createdDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
    {
      header: 'By',
      accessorKey: 'user.lastName',
      size: 125,
      cell: ({ row }) => <Tooltip title={row.original.user?.email}>{row.original.user?.fullName}</Tooltip>,
    },
    {
      header: 'Message',
      accessorKey: 'comment',
      enableColumnFilter: true,
      cell: ({ row }) => {
        if (row.original.isSecondaryReference) {
          return (
            <Link to={`/tasksqueue/${row.original.subjectId}`} target={'_blank'} style={{ textDecoration: 'none', color: '#000' }}>
              <RichTextReadOnly content={row.original.comment} extensions={extensions} />
            </Link>
          );
        } else {
          return <RichTextReadOnly content={row.original.comment} extensions={extensions} />;
        }
      },
    },
  ] as Array<any>;

  return col;
};
